export const LABELS = {
  title: "Title",
  forename: "Forename",
  middleName: "Middle Name",
  surname: "Surname",
  dob: "Date of Birth",
  previousName: "Previous Full Name",
  dateOfChange: "Date of Change",
  nationality: "Nationality",
  hasPermanentUkResideRight:
    "Does the applicant have permanent right to reside in the UK?",
  phoneNumber: "Phone number",
  email: "Email address",
  maritalStatus: "Marital Status",
  address: {
    stayDurationYears:
      "How long has the applicant been at this address (Years)?",
    stayDurationMonths:
      "How long has the applicant been at this address (Months)?",
    residentialStatus: "Residential Status",
    addressLine1: "Address Line 1",
    addressLine2: "Address Line 2",
    addressLine3: "Address Line 3",
    townOrCity: "Town or city",
    county: "County",
    postcode: "Postcode",
  },
};
